import { render } from "./SectionShop.vue?vue&type=template&id=d64ae810&scoped=true"
import script from "./SectionShop.vue?vue&type=script&lang=js"
export * from "./SectionShop.vue?vue&type=script&lang=js"

import "./SectionShop.vue?vue&type=style&index=0&id=d64ae810&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64ae810"]])

export default __exports__